import { useEffect } from 'react';
import { envStrToBoolean } from 'src/helpers/utils';
import { EnumDialogsKeys, EnumStatusesOfKyc } from '../store/dialog/types';

const useKycPopup = (
  kycStatus: string,
  user: Record<string, string>,
  section: string,
  _openDialog: (props: any) => void
): void => {
  const isKycGameEnable = envStrToBoolean(process.env.REACT_APP_KYC_OTHER_ENABLE);
  useEffect(() => {
    if (
      user &&
      isKycGameEnable &&
      !section &&
      [EnumStatusesOfKyc.PENDING, EnumStatusesOfKyc.EXPIRED, EnumStatusesOfKyc.REJECTED, undefined].includes(
        kycStatus as EnumStatusesOfKyc | undefined
      )
    ) {
      const interval = setInterval(() => {
        _openDialog({
          dialogType: EnumDialogsKeys.KYC_POPUP,
          dialogProps: { data: {} },
        });
      }, 1000);

      return () => clearInterval(interval);
    }
    return undefined;
  }, [kycStatus, user, section]);
};

export default useKycPopup;
